module.exports = __webpack_public_path__ + "static/person-5-70x70-ec6b3a42d4980d1007e51dfbbf020bb2.png";